import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches the product launch gate status ({ locked, launch_date, override }).
export function useLaunchStatus() {
  const [status, setStatus] = useState(null); // null = loading
  useEffect(() => {
    let active = true;
    api
      .get("/launch-status")
      .then(({ data }) => active && setStatus(data))
      .catch(() => active && setStatus({ locked: false, launch_date: null, override: "auto" }));
    return () => {
      active = false;
    };
  }, []);
  return status;
}
